const HomePageHandler = (product, event, data) => {
    const { metaData = {}, url = '', travelDate = '', journeyClass = '', fromStation = '', toStation = '' } = data,
        [originCode, originName] = fromStation.split('-'),
        [destinationCode, destinationName] = toStation.split('-'),
        { userId, name = '', email = '', mobile = '', balance = 0 } = metaData;

    let finalData = {
        userId: userId, userName: name, userEmail: email, userContact: mobile, walletBalance: balance, urlPath: url, product: product
    }

    switch (event) {
        case 'PageView':
            break;
        case 'Search':
            finalData = { ...finalData, journeyDate: travelDate, journeyClass, originCode, originName, destinationCode, destinationName }
            break;
        case 'RecentSearch':
            break;
        case 'MyBookings':
            break;
        case 'TDRrequest':
            break;
        case 'BookingCalendar':
            break;
        case 'Cancellation&Refunds':
            break;
        case 'AuthorisationCertificate':
            break;
    }
    return finalData;
}

module.exports = { HomePageHandler }